import React from "react";
import { HeroSection } from "../Component/HeroSection";
import { Aboutus } from "../Component/Aboutus";
import { MainProjects } from "../Component/MainProjects";
import { MainBlogs } from "../Component/MainBlogs";
import { MainTestominials } from "../Component/MainTestominials";
import { MainOurDevelopers } from "../Component/MainOurDevelopers";
import { MainContactUs } from "../Component/MainContactUs";
import { MainHowItWorks } from "../Component/MainHowItWorks";
import { ListWithUs } from "../Component/ListWithUs";
import { MainAwards } from "../Component/MainAwards";
import { useSeo } from "../Utility/Seo";

export const HomePage = () => {
  useSeo("/");
  return (
    <main>
      <HeroSection />
      <Aboutus />
      <MainOurDevelopers />
      <MainProjects />
      <MainHowItWorks />
      <MainBlogs />
      <MainTestominials />
      <MainAwards />
      <ListWithUs />
      <MainContactUs />
    </main>
  );
};
